@if(step === 'search') {
    <app-p2p-champion-and-donor-search (itemSelected)="seeItemDetails($event)"></app-p2p-champion-and-donor-search>
}

@if(step === 'viewDonations') {
    @if(placeOfCall === 'viewDonations' && step === 'viewDonations') {
        <div class="d-flex mt-n3 mb-3">
            <button type="button" class="close" (click)="close()">
                <span aria-hidden="true" class="black-text" style="cursor: pointer;font-weight:400;">&times;</span>
            </button>
        </div>
    }
    
    @if(placeOfCall === 'search' && step === 'viewDonations') {
        <div (click)="backToSearch()" class="d-flex mb-3">
            <div class="cursor--pointer">
                <i class="fas fa-chevron-left mr-2"></i>
                <span class="body-2 cursor--pointer">Back To Search</span>
            </div>
        </div>
    }
    
    <app-p2p-details-donations (selectedDonor)="seeItemDetails($event)" [data]="fundraiserData" [activeTab]="activeTab"></app-p2p-details-donations>
}

@if(step === 'itemDetails') {
    <div (click)="backToPrevStep()" class="cursor--pointer">
        <i class="fas fa-chevron-left mr-2"></i>
        @if(prevStep === 'search') {
            <span class="body-2 cursor--pointer">Back To Search</span>
        }
        @if(prevStep === 'viewDonations') {
            <span class="body-2 cursor--pointer">Back To Donations</span>
        }
    </div>
    <app-p2p-donor-details (selectedFundraiser)="viewFundraiserDonations($event)" [donation]="selectedItem"></app-p2p-donor-details>
}